import React, { useEffect , useState} from 'react';
import { Tooltip, P2, P3, Row, Col, B1, CheckBox, SelectDropdown, Input, Button } from 'pfm-ui-components';
import { up, down } from 'styled-breakpoints';
import styled from 'styled-components';
import { checkBoxStyling, dropDownStyling, inputStylingProps } from '../../../../styles/common';
import * as constants from '../../../../constants/investTransactPage';
import { pxToRem } from '../../../../styles/utils';
import InfoIcon from '../../../../assets/icons/info-hover.svg';
import {
  formatValueForDropDown,
  convertArrayOfStringsToDropDownOptionsFormatWithSecondaryLabel,
  getSipFrequencyOptions,
  getMinimumSipAmount,
  getPreferredDates,
} from './util';
import { convertArrayOfStringsToDropDownOptionsFormat, addNewFolio } from '../utils';
import { deformatMoney, formatMoney, formatMoneyWithoutRupeeSymbol } from '../../../../utils/calculations';
import { BuyDetailsProps} from '../../../../pages/transact/invest';
import { InvestmentIdDetails } from '../../../../pages/transact/invest';
import {getDateOrdinal } from '../../../../utils/date';
import { LOCK_IN_PERIOD, MONTHLY} from '../../../../constants/common';
import { SAVE_TAX_SUB_CAT } from '../../../../constants/ExplorePage';
import { useAppContext } from '../../../../store';
import { getInvestmentIdsOptionsWithName } from '../../../../utils/dropdownName';
import { useDeviceType } from '../../../../utils/deviceType';
import DEVICE_TYPE from '../../../../constants/device';
import { InvestFrequency } from '../../../../pages/transact/invest';

interface TransactionCardProps {
  hasAlreadyInvested: boolean;
  formik: any;
  onChange: Function;
  nomineeSelected: boolean;
  preferredDates: Array<string>;
  isShowMonthlySip: boolean;
  isShowOneTime: boolean;
  minimumAmount: number;
  minSipAmount: number;
  accountHolder: string;
  foliosObject: any;
  investmentIdsDetails: Array<InvestmentIdDetails>;
  redirectedFromPlanYourGoalWithSip: boolean;
  isRenewSip: boolean;
  valueDate: string;
  buyDetails: BuyDetailsProps;
  changeInvestmentId: Function;
  minSipInstallment: number;
  isNfo: boolean;
  fundCodeOptionSelected: string;
  sipFrequencies: Array<InvestFrequency>;
  setSipDetails?: Function;
}

interface HeaderWrapperProps {
  hasAlreadyInvested: boolean;
  formik: any;
  onChange: Function;
  nomineeSelected: boolean;
  foliosObject: any;
  investmentIdsDetails: Array<InvestmentIdDetails>;
  redirectedFromPlanYourGoalWithSip: boolean;
  isRenewSip: boolean;
  changeInvestmentId: Function;
  sipFrequencies: Array<InvestFrequency>;
  setSipDetails?: Function;
}

const folioNumberRef = React.createRef();
const investmentAmountRef = React.createRef();
const NumberOfInstallmentRef = React.createRef();
const installmentFrequencyRef = React.createRef();
const scheduleSipDateRef = React.createRef();
const InvestmentTimeFrameRef = React.createRef();
const investmentIdRef = React.createRef();

const HeaderWrapper = (props: HeaderWrapperProps) => {
  const {setState, state} = useAppContext();
  const {
    formik,
    hasAlreadyInvested,
    nomineeSelected,
    onChange,
    foliosObject,
    investmentIdsDetails,
    redirectedFromPlanYourGoalWithSip,
    isRenewSip,
    changeInvestmentId,
    sipFrequencies,
  } = props;
  const [folios,SetFolios] = useState(addNewFolio(formik?.values?.folioNumber))
  const isMobile = useDeviceType() === DEVICE_TYPE.MOBILE;
  return (
    <HeaderContainer hasAlreadyInvested={hasAlreadyInvested} nomineeSelected={nomineeSelected}>
       {isMobile ? (
      <StyledRow disable={!hasAlreadyInvested}>
         {investmentIdsDetails?.length > 1 && (
      <StyledColHoldings xs={6} md={4} disable={investmentIdsDetails?.length < 2 || isRenewSip}>
          <SelectDropDownWrapper reduceWidth={true}>
            <SelectDropdownLabel>       
              <InputFieldLabelID>  {constants.INVESTMENT_ID}
                </InputFieldLabelID>
                      </SelectDropdownLabel>
            <SelectDropdownContainer>
              <SelectDropdown
                className="dropdown-v2"
                placeholder="Select"
                dropdownStyling={dropDownStyling}
                shouldShowAsterisk={false}
                rotateDropdownIcon={true}
                innerRef={investmentIdRef}
                options={convertArrayOfStringsToDropDownOptionsFormatWithSecondaryLabel(
                  investmentIdsDetails,
                  'inv_ID',
                  'name'
                )}
                onChange={(investmentId) => {
                  setState({...state, currentInvestmentId: investmentId?.value})
                  onChange('investmentId', investmentId?.value);
                  changeInvestmentId(investmentId?.value);
                }}
                value={formik?.values?.investmentId && formatValueForDropDown(formik?.values?.investmentId)}
              />
            </SelectDropdownContainer>
            <TooltipWrapperNew>
          <Tooltip
            content={
              <div>
                <TooltipSubHeadingNew>{constants.INVESTMENT_ID_TOOLTIP}</TooltipSubHeadingNew>
              </div>
            }
            className="tooltipStyle"
          >
            <ToolTipIconMobile>
              <InfoIcon />
            </ToolTipIconMobile>
          </Tooltip>
        </TooltipWrapperNew>
          </SelectDropDownWrapper>
        </StyledColHoldings>
         )}
          {Object.keys(foliosObject)[0] !== 'New Folio' &&(
        <StyledColHoldings xs={6} md={4}>
            <SelectDropDownWrapper style={{marginBottom:'50px'}} reduceWidth ={true} addLeftMargin={isRenewSip ? false : true}>
              <SelectDropdownLabelFolio>{constants.FOLIO_NUMBER} 
              </SelectDropdownLabelFolio>
              <SelectDropdownContainer>
                <SelectDropdown
                  className="dropdown-v2"
                  placeholder="Select"
                  dropdownStyling={dropDownStyling}
                  shouldShowAsterisk={false}
                  rotateDropdownIcon={true}
                  innerRef={folioNumberRef}
                  options={folios}
                  onChange={(folio) => onChange('folioNumber', folio.value)}
                  value={formik?.values?.folioNumber && formatValueForDropDown(formik?.values?.folioNumber)}
                  error={formik?.errors?.folioNumber && formik?.touched?.folioNumber}
                  errorMsg={formik?.errors?.folioNumber}
                />
              </SelectDropdownContainer>
              <TooltipWrapperHoldings>
                      <Tooltip
                        content={
                          <div>
                            <TooltipSubHeading>{constants.FOLIO_NUMBER_TOOLTIP}</TooltipSubHeading>
                          </div>
                        }
                        className="tooltipStyle"
                      >
                        <TooltipIconFolioMobile>
                          <InfoIcon />
                        </TooltipIconFolioMobile>
                      </Tooltip> </TooltipWrapperHoldings>
            </SelectDropDownWrapper>
        </StyledColHoldings>
          )}
      </StyledRow> 
       
      ):(
       <StyledRow disable={!hasAlreadyInvested}>
         {investmentIdsDetails?.length > 1 && (
      <StyledCol xs={6} md={4} disable={investmentIdsDetails?.length < 2 || isRenewSip}>
          <SelectDropDownWrapper reduceWidth={true}>
          <SelectDropdownLabel>
                <InputFieldLabel>  {constants.INVESTMENT_ID}
                  <TooltipWrapper>
                    <Tooltip
                      content={
                        <div>
                          <TooltipSubHeading>{constants.INVESTMENT_ID_TOOLTIP}</TooltipSubHeading>
                        </div>
                      }
                      className="tooltipStyle"
                    >
                      <TooltipIcon>
                        <InfoIcon />
                      </TooltipIcon>
                    </Tooltip></TooltipWrapper>
                </InputFieldLabel>

              </SelectDropdownLabel>
            <SelectDropdownContainer>
              <SelectDropdown
                className="dropdown-v2"
                placeholder="Select"
                dropdownStyling={dropDownStyling}
                shouldShowAsterisk={false}
                rotateDropdownIcon={true}
                innerRef={investmentIdRef}
                options={convertArrayOfStringsToDropDownOptionsFormatWithSecondaryLabel(
                  investmentIdsDetails,
                  'inv_ID',
                  'name'
                )}
                onChange={(investmentId) => {
                  setState({...state, currentInvestmentId: investmentId?.value})
                  onChange('investmentId', investmentId?.value);
                  changeInvestmentId(investmentId?.value);
                }}
                value={formik?.values?.investmentId && formatValueForDropDown(formik?.values?.investmentId)}
              />
            </SelectDropdownContainer>
          </SelectDropDownWrapper>
        </StyledCol>
         )}
        {Object.keys(foliosObject)[0] !== 'New Folio' &&(
        <StyledCol xs={6} md={4}>
            <SelectDropDownWrapperFOLIO style={{marginBottom:'60px'}} addLeftMargin={isRenewSip ? false : true}>
              <SelectDropdownLabelFOLIO>{constants.FOLIO_NUMBER}
              </SelectDropdownLabelFOLIO>
              <SelectDropdownContainer>
                <SelectDropdown
                  className="dropdown-v2"
                  placeholder="Select"
                  dropdownStyling={dropDownStyling}
                  shouldShowAsterisk={false}
                  rotateDropdownIcon={true}
                  innerRef={folioNumberRef}
                  options={folios}
                  onChange={(folio) => onChange('folioNumber', folio.value)}
                  value={formik?.values?.folioNumber && formatValueForDropDown(formik?.values?.folioNumber)}
                  error={formik?.errors?.folioNumber && formik?.touched?.folioNumber}
                  errorMsg={formik?.errors?.folioNumber}
                />
              </SelectDropdownContainer>
              <TooltipWrapperHoldingsDevice>
                  <Tooltip
                    content={
                      <div>
                        <TooltipSubHeading>{constants.FOLIO_NUMBER_TOOLTIP}</TooltipSubHeading>
                      </div>
                    }
                    className="tooltipStyle"
                  >
                    <TooltipIcon>
                      <InfoIcon />
                    </TooltipIcon>
                  </Tooltip></TooltipWrapperHoldingsDevice>
            </SelectDropDownWrapperFOLIO>
        </StyledCol>
          )}
      </StyledRow> 
      )}
      {isMobile ? (
        <StyledRowMobile disable={hasAlreadyInvested}>
           {investmentIdsDetails?.length > 1 && (
          <StyledCol xs={6} md={4} disable={investmentIdsDetails?.length < 2 || isRenewSip}>
            <SelectDropDownWrapper reduceWidth={true}>
              <SelectDropdownLabel>
                <InputFieldLabelID>  {constants.INVESTMENT_ID}
                </InputFieldLabelID>
              </SelectDropdownLabel>
              <SelectDropdownContainer>
                <SelectDropdown
                  className="dropdown-v2"
                  placeholder="Select"
                  dropdownStyling={dropDownStyling}
                  shouldShowAsterisk={false}
                  rotateDropdownIcon={true}
                  innerRef={investmentIdRef}
                  options={getInvestmentIdsOptionsWithName(investmentIdsDetails)}
                  onChange={(investmentId) => {
                    setState({ ...state, currentInvestmentId: investmentId?.value });
                    onChange('investmentId', investmentId?.value);
                    changeInvestmentId(investmentId?.value);
                  }}
                  value={formik?.values?.investmentId && formatValueForDropDown(formik?.values?.investmentId)}
                />
              </SelectDropdownContainer>
              <TooltipWrapperNew>
          <Tooltip
            content={
              <div>
                <TooltipSubHeadingNew>{constants.INVESTMENT_ID_TOOLTIP}</TooltipSubHeadingNew>
              </div>
            }
            className="tooltipStyle"
          >
            <ToolTipIconMobile>
              <InfoIcon />
            </ToolTipIconMobile>
          </Tooltip>
        </TooltipWrapperNew>
            </SelectDropDownWrapper>
          </StyledCol>
           )}
             {Object.keys(foliosObject)[0] !== 'New Folio' &&(
          <StyledColFolio xs={6} md={4}>
            {Object.keys(foliosObject).length === 1 ? (
              <InputWrapper reduceWidth = {true}>
                <InputFieldLabelFOLIO>
                  {constants.FOLIO_NUMBER}
                </InputFieldLabelFOLIO>
                <InputFieldContainer>
                  <Input
                    name="folioNumber"
                    className="inputField-v2"
                    inputStylingProps={inputStylingProps}
                    value={formik?.values?.folioNumber}
                    disabled
                    innerRef={folioNumberRef}
                  />
                </InputFieldContainer>
              </InputWrapper>
            ) : (
              <StyledColFOLIO style={investmentIdsDetails?.length > 1 ? {maxWidth:'98%'} : {maxWidth:'55%'}}>
              <SelectDropDownWrapper reduceWidth={true} addLeftMargin={isRenewSip ? false : true}>
                <SelectDropdownLabelFolio>{constants.FOLIO_NUMBER} 
                </SelectDropdownLabelFolio>
                <SelectDropdownContainer>
                  <SelectDropdown
                    className="dropdown-v2"
                    placeholder="Select"
                    dropdownStyling={dropDownStyling}
                    shouldShowAsterisk={false}
                    rotateDropdownIcon={true}
                    innerRef={folioNumberRef}
                    options={convertArrayOfStringsToDropDownOptionsFormat(Object.keys(foliosObject))}
                    onChange={(folio) => onChange('folioNumber', folio?.value)}
                    value={formik?.values?.folioNumber && formatValueForDropDown(formik?.values?.folioNumber)}
                    error={formik?.errors?.folioNumber && formik?.touched?.folioNumber}
                    errorMsg={formik?.errors?.folioNumber}
                  />
                </SelectDropdownContainer>
                <TooltipWrapperNew>
          <Tooltip
            content={
              <div>
                <TooltipSubHeadingNew>{constants.FOLIO_NUMBER_TOOLTIP}</TooltipSubHeadingNew>
              </div>
            }
            className="tooltipStyle"
          >
            <ToolTipIconMobileNew>
              <InfoIcon />
            </ToolTipIconMobileNew>
          </Tooltip>
        </TooltipWrapperNew>
              </SelectDropDownWrapper>
              </StyledColFOLIO>
            )}
          </StyledColFolio>
)}
          {/* <StyledCol
            xs={6}
            md={4}
            disable={formik.values.sipOrLumpsumOption !== constants.SIP || !redirectedFromPlanYourGoalWithSip}
          >
            <SelectDropDownWrapper>
              <SelectDropdown
                label={constants.FREQUENCY}
                className="dropdown-v2"
                innerRef={installmentFrequencyRef}
                placeholder="Select"
                dropdownStyling={dropDownStyling}
                shouldShowAsterisk={false}
                rotateDropdownIcon={true}
                options={getSipFrequencyOptions(sipFrequencies)}
                onChange={(frequency) => {
                  onChange('frequency', frequency.value);
                  onChange('sipOrLumpsumOption', constants.SIP);
                  setSipDetails(frequency.value);
                }}
                value={formik.values.frequency && formatValueForDropDown(formik.values.frequency)}
                error={formik.touched.frequency && formik.errors.frequency}
                errorMsg={formik.errors.frequency}
              />
            </SelectDropDownWrapper>
          </StyledCol> */}
        </StyledRowMobile>
      ) : (
        <StyledRow disable={hasAlreadyInvested}>
           {investmentIdsDetails?.length > 1 && (
          <StyledCol xs={6} md={4} disable={investmentIdsDetails?.length < 2 || isRenewSip}>
            <SelectDropDownWrapper reduceWidth={true}>
              <SelectDropdownLabel>
              <InputFieldLabel>  {constants.INVESTMENT_ID}
              <TooltipWrapper>
              <Tooltip
                      content={
                        <div>
                          <TooltipSubHeading>{constants.INVESTMENT_ID_TOOLTIP}</TooltipSubHeading>
                        </div>
                      }
                      className="tooltipStyle"
                    >
                      <TooltipIcon>
                        <InfoIcon />
                      </TooltipIcon>
                    </Tooltip></TooltipWrapper>
                </InputFieldLabel>
                
              </SelectDropdownLabel>
              <SelectDropdownContainer>
                <SelectDropdown
                  className="dropdown-v2"
                  placeholder="Select"
                  dropdownStyling={dropDownStyling}
                  shouldShowAsterisk={false}
                  rotateDropdownIcon={true}
                  innerRef={investmentIdRef}
                  options={getInvestmentIdsOptionsWithName(investmentIdsDetails)}
                  onChange={(investmentId) => {
                    setState({ ...state, currentInvestmentId: investmentId?.value });
                    onChange('investmentId', investmentId?.value);
                    changeInvestmentId(investmentId?.value);
                  }}
                  value={formik?.values?.investmentId && formatValueForDropDown(formik?.values?.investmentId)}
                />
              </SelectDropdownContainer>
            </SelectDropDownWrapper>
          </StyledCol>
           )}
             {Object.keys(foliosObject)[0] !== 'New Folio' &&(
          <StyledColFOLIO xs={6} md={4}>
            {Object.keys(foliosObject).length === 1 ? (
              <InputWrapperFOLIODevice>
                <InputFieldLabelDeviceSIP>
                  {constants.FOLIO_NUMBER}
                  <TooltipWrapper>
                    <Tooltip
                      content={
                        <div>
                          <TooltipSubHeading>{constants.FOLIO_NUMBER_TOOLTIP}</TooltipSubHeading>
                        </div>
                      }
                      className="tooltipStyle"
                    >
                      <TooltipIcon>
                        <InfoIcon />
                      </TooltipIcon>
                    </Tooltip></TooltipWrapper>
                </InputFieldLabelDeviceSIP>
                <InputFieldContainer>
                  <Input
                    name="folioNumber"
                    className="inputField-v2"
                    inputStylingProps={inputStylingProps}
                    value={formik?.values?.folioNumber}
                    disabled
                    innerRef={folioNumberRef}
                  />
                </InputFieldContainer>
              </InputWrapperFOLIODevice>
            ) : (
              <StyledColFOLIONew>
              <SelectDropDownWrapper style={{marginBottom:'60px'}} addLeftMargin={isRenewSip ? false : true}>
                <SelectDropdownLabelFOLIO>{constants.FOLIO_NUMBER}
                </SelectDropdownLabelFOLIO>

                <SelectDropdownContainer>
                  <SelectDropdown
                    className="dropdown-v2"
                    placeholder="Select"
                    dropdownStyling={dropDownStyling}
                    shouldShowAsterisk={false}
                    rotateDropdownIcon={true}
                    innerRef={folioNumberRef}
                    options={convertArrayOfStringsToDropDownOptionsFormat(Object.keys(foliosObject))}
                    onChange={(folio) => onChange('folioNumber', folio?.value)}
                    value={formik?.values?.folioNumber && formatValueForDropDown(formik?.values?.folioNumber)}
                    error={formik?.errors?.folioNumber && formik?.touched?.folioNumber}
                    errorMsg={formik?.errors?.folioNumber}
                  />
                </SelectDropdownContainer>
                <TooltipWrapperFOLIODevice>
                  <Tooltip
                    content={
                      <div>
                        <TooltipSubHeading>{constants.FOLIO_NUMBER_TOOLTIP}</TooltipSubHeading>
                      </div>
                    }
                    className="tooltipStyle"
                  >
                    <TooltipIcon>
                      <InfoIcon />
                    </TooltipIcon>
                  </Tooltip></TooltipWrapperFOLIODevice>
              </SelectDropDownWrapper>
              </StyledColFOLIONew>     
            )}
          </StyledColFOLIO> 
             )} 
             </StyledRow>
      )}
          {/* <StyledCol
            xs={12}
            md={4}
            disable={formik.values.sipOrLumpsumOption !== constants.SIP || !redirectedFromPlanYourGoalWithSip}
          >
            <SelectDropDownWrapper>
              <SelectDropdown
                label={constants.FREQUENCY}
                className="dropdown-v2"
                innerRef={installmentFrequencyRef}
                placeholder="Select"
                dropdownStyling={dropDownStyling}
                shouldShowAsterisk={false}
                rotateDropdownIcon={true}
                options={getSipFrequencyOptions(sipFrequencies)}
                onChange={(frequency) => {
                  onChange('frequency', frequency.value);
                  onChange('sipOrLumpsumOption', constants.SIP);
                  setSipDetails(frequency.value);
                }}
                value={formik.values.frequency && formatValueForDropDown(formik.values.frequency)}
                error={formik.touched.frequency && formik.errors.frequency}
                errorMsg={formik.errors.frequency}
              />
            </SelectDropDownWrapper>
          </StyledCol> */}
       
    </HeaderContainer>
  );
};
export default function TransactionCard(props: TransactionCardProps) {
  const {
    formik,
    hasAlreadyInvested,
    onChange,
    nomineeSelected,
    preferredDates,
    isShowMonthlySip,
    isShowOneTime,
    minimumAmount,
    minSipAmount,
    accountHolder,
    foliosObject,
    investmentIdsDetails,
    redirectedFromPlanYourGoalWithSip,
    isRenewSip,
    valueDate,
    buyDetails,
    changeInvestmentId,
    minSipInstallment,
    isNfo,
    fundCodeOptionSelected,
    sipFrequencies,
    setSipDetails,
  } = props;

  const onAmountChange = (value) => {
    const amount = deformatMoney(value);
    return amount;
  };

  const quickSelectAmount = ['20000', '50000', '70000'];
  const quickSelectAmountSIP = ['3000', '5000', '10000'];
  const [selectedAmount, setSelectedAmount] = useState<string>();
  const [selectedOption, setSelectedOption] = useState('lumpsum');
  const isMobile = useDeviceType() === DEVICE_TYPE.MOBILE;

  return (
    <>
      <TransactionCardWrapper>
        <TransactionCardHeader>
          <Heading>{constants.INVESTMENT_DETAILS}</Heading>
        </TransactionCardHeader>
 
        <BodyContainer>
          
          {isMobile ? (
            <CheckBoxGroupWrapper disable={redirectedFromPlanYourGoalWithSip || isRenewSip}>
                <StyledCheckBox 
                  visible={false}
                  label={constants.LUMPSUM}
                  name="sipOrLumpsumOption"
                  labelColor={selectedOption === 'lumpsum' ? '#97144D' : '#BAB9B9'}
                  style={{ fontSize: '14px', justifyContent: 'start', marginRight: '20px'}}
                  checked={formik?.values?.sipOrLumpsumOption === constants.LUMPSUM}
                  onChange={() => {
                    onChange('sipOrLumpsumOption', constants.LUMPSUM)
                    setSelectedOption('lumpsum');
                     onChange('amount',50000) 
                  }}
                  enable={isShowOneTime && !redirectedFromPlanYourGoalWithSip}
                  className={selectedOption === 'lumpsum' ? 'lumpsum-selected' : ''}
                />
              <StyledColSip xs={6} md={4}>
                <StyledCheckBox
                  visible={false}
                  label={constants.SIP}
                  name="sipOrLumpsumOption"
                  labelColor={selectedOption === 'sip' ? '#97144D' : '#BAB9B9'}
                  style={{ fontSize: '14px', marginLeft: '12px', justifyContent: 'center', marginRight: '40px' }}
                  checked={formik?.values?.sipOrLumpsumOption === constants.SIP}
                  onChange={() => {
                    onChange('sipOrLumpsumOption', constants.SIP)
                    setSelectedOption('sip');
                      onChange('amount',5000) 
                  }}
                  enable={isShowMonthlySip}
                  className={selectedOption === 'sip' ? 'sip-selected' : ''}
                />
              </StyledColSip>
            </CheckBoxGroupWrapper>
          ) : (
            <CheckBoxGroupWrapper disable={redirectedFromPlanYourGoalWithSip || isRenewSip}>
              <StyledCheckBox
                visible={false}
                label={constants.LUMPSUM}
                name="sipOrLumpsumOption"
                labelColor={selectedOption === 'lumpsum' ? '#97144D' : '#BAB9B9'}
                style={{ marginLeft: '20px' }}
                checked={formik?.values?.sipOrLumpsumOption === constants.LUMPSUM}
                onChange={() => {
                  onChange('sipOrLumpsumOption', constants.LUMPSUM)
                  setSelectedOption('lumpsum');
                  onChange('amount',50000)
                }}
                enable={isShowOneTime && !redirectedFromPlanYourGoalWithSip}
                className={selectedOption === 'lumpsum' ? 'lumpsum-selected' : ''}
              />
              <StyledCheckBox 
                visible={false}
                label={constants.SIP}
                name="sipOrLumpsumOption"
                labelColor={selectedOption === 'sip' ? '#97144D' : '#BAB9B9'}
                style={{ marginLeft: '30px' }}
                checked={formik?.values?.sipOrLumpsumOption === constants.SIP}
                onChange={() => {
                  onChange('sipOrLumpsumOption', constants.SIP)
                  setSelectedOption('sip');
                  onChange('amount',5000)
                }}
                enable={isShowMonthlySip}
                className={selectedOption === 'sip' ? 'sip-selected' : ''}
              />
            </CheckBoxGroupWrapper>
          )}

          <Wrapper
            reduceBottomPadding={formik?.values?.sipOrLumpsumOption === constants.LUMPSUM}
            removeTopPadding={redirectedFromPlanYourGoalWithSip || isRenewSip}
          >
            <HeaderWrapper
              {...{
                formik,
                nomineeSelected,
                onChange,
                hasAlreadyInvested,
                foliosObject,
                investmentIdsDetails,
                redirectedFromPlanYourGoalWithSip,
                isRenewSip,
                changeInvestmentId,
                sipFrequencies,
                setSipDetails,
              }}
            />
            <StyledRow>
              {/* <StyledCol
                xs={12}
                md={4}
                disable={formik.values.sipOrLumpsumOption !== constants.SIP || redirectedFromPlanYourGoalWithSip}
              > 
                <SelectDropDownWrapper>
                  <SelectDropdown
                    label={constants.FREQUENCY}
                    className="dropdown-v2"
                    innerRef={installmentFrequencyRef}
                    placeholder="Select"
                    dropdownStyling={dropDownStyling}
                    shouldShowAsterisk={false}
                    rotateDropdownIcon={true}
                    options={getSipFrequencyOptions(sipFrequencies)}
                    onChange={(frequency) => {
                      onChange('frequency', frequency.value);
                      setSipDetails(frequency.value);
                    }}
                    value={formik.values.frequency && formatValueForDropDown(formik.values.frequency)}
                    error={formik.touched.frequency && formik.errors.frequency}
                    errorMsg={formik.errors.frequency}
                  />
                </SelectDropDownWrapper> 
               </StyledCol> */}

              {isMobile ? (
                <StyledColSIPDate xs={6} md={4} disable={formik?.values?.sipOrLumpsumOption !== constants.SIP}>
                  <SelectDropDownWrapperMobile reduceWidth ={true}>
                    <InputWrapper><InputFieldLabel>{isNfo ? constants.SIP_DATE_NFO : constants.SIP_DATE}</InputFieldLabel></InputWrapper>
                    <InputFieldContainer>
                      <SelectDropdown
                        //label={isNfo ? constants.SIP_DATE_NFO : constants.SIP_DATE}
                        className="dropdown-v2"
                        placeholder="Select"
                        name="scheduleDate"
                        dropdownStyling={dropDownStyling}
                        innerRef={scheduleSipDateRef}
                        shouldShowAsterisk={false}
                        rotateDropdownIcon={true}
                        options={convertArrayOfStringsToDropDownOptionsFormat(
                          getPreferredDates(formik?.values?.frequency, sipFrequencies),
                          formik?.values?.frequency === MONTHLY,
                          ' of every month'
                        )}
                        // inputFieldSuffix={
                        //   formik.values.scheduleDate ? `Starting from ${getDateAsPerScheduleDateFormat(valueDate)} ` : ''
                        // }
                        onChange={(sipDate) => onChange('scheduleDate', sipDate.value)}
                        value={
                          formik?.values?.scheduleDate &&
                          formatValueForDropDown(
                            formik?.values?.frequency === MONTHLY
                              ? getDateOrdinal(formik?.values?.scheduleDate) + '  of every month'
                              : formik?.values?.scheduleDate
                          )
                        }
                        error={formik?.touched?.scheduleDate && formik?.errors?.scheduleDate}
                        errorMsg={formik?.errors?.scheduleDate}
                      />
                    </InputFieldContainer>
                  </SelectDropDownWrapperMobile>
                </StyledColSIPDate>

              ) : (
                <StyledCol xs={6} md={4} disable={formik?.values?.sipOrLumpsumOption !== constants.SIP}>
                  <SelectDropDownWrapperSIP style={Object.keys(foliosObject).length === 1 && investmentIdsDetails?.length < 2 ? {marginTop:'50px'} : {marginTop:'30px'}}>
                    <InputWrapperSIPWeb><InputFieldLabelSIP>{isNfo ? constants.SIP_DATE_NFO : constants.SIP_DATE}</InputFieldLabelSIP>
                      <InputFieldContainer>
                        <SelectDropdown
                          //label={isNfo ? constants.SIP_DATE_NFO : constants.SIP_DATE}
                          className="dropdown-v2"
                          placeholder="Select"
                          name="scheduleDate"
                          dropdownStyling={dropDownStyling}
                          innerRef={scheduleSipDateRef}
                          shouldShowAsterisk={false}
                          rotateDropdownIcon={true}
                          options={convertArrayOfStringsToDropDownOptionsFormat(
                            getPreferredDates(formik?.values?.frequency, sipFrequencies),
                            formik?.values?.frequency === MONTHLY,
                            ' of every month'
                          )}
                          // inputFieldSuffix={
                          //   formik.values.scheduleDate ? `Starting from ${getDateAsPerScheduleDateFormat(valueDate)} ` : ''
                          // }
                          onChange={(sipDate) => onChange('scheduleDate', sipDate.value)}
                          value={
                            formik?.values?.scheduleDate &&
                            formatValueForDropDown(
                              formik?.values?.frequency === MONTHLY
                                ? getDateOrdinal(formik?.values?.scheduleDate) + '  of every month'
                                : formik?.values?.scheduleDate
                            )
                          }
                          error={formik?.touched?.scheduleDate && formik?.errors?.scheduleDate}
                          errorMsg={formik?.errors?.scheduleDate}
                        />
                      </InputFieldContainer>
                    </InputWrapperSIPWeb>
                  </SelectDropDownWrapperSIP>
                </StyledCol>
              )}

              {isMobile ? (
                <StyledColSIP xs={6} md={4} disable={formik?.values?.sipOrLumpsumOption !== constants.SIP}>
                  <InputWrapperMobileInstallment reduceWidth={true} addLeftMargin={true}>
                    <InputFieldLabel>{constants.NUMBER_OF_INSTALLMENT}</InputFieldLabel>
                    <InputFieldContainerInstallment>
                      <Input
                        maxLength={3}
                        name="noOfInstallment"
                        className="inputField-v2"
                        inputStylingProps={inputStylingProps}
                        placeholder={constants.UNTIL_CANCELLED}
                        innerRef={NumberOfInstallmentRef}
                        onChange={(e) => onChange('noOfInstallment', e.target.value)}
                        value={formik?.values?.noOfInstallment}
                        error={
                          formik?.touched?.noOfInstallment && formik?.errors?.noOfInstallment
                            ? formik?.errors?.noOfInstallment
                            : false
                        }
                        onBlur={formik?.handleBlur}
                      />
                    </InputFieldContainerInstallment>
                  </InputWrapperMobileInstallment>
                </StyledColSIP>
              ) : (
                <>
                <StyledCol xs={6} md={4} disable={formik.values.sipOrLumpsumOption !== constants.SIP}>
                  <InputWrapperFOLIO addLeftMargin={true} style={Object.keys(foliosObject).length === 1 && investmentIdsDetails?.length < 2 ? {marginTop:'46px'} : {marginTop:'25.8px'}}>
                    <InputFieldLabelDeviceSIP>{constants.NUMBER_OF_INSTALLMENT}</InputFieldLabelDeviceSIP>
                    <InputFieldContainerInstallmentWeb>
                      <Input
                        maxLength={3}
                        name="noOfInstallment"
                        className="inputField-v2"
                        inputStylingProps={inputStylingProps}
                        placeholder={constants.UNTIL_CANCELLED}
                        innerRef={NumberOfInstallmentRef}
                        onChange={(e) => onChange('noOfInstallment', e.target.value)}
                        value={formik?.values?.noOfInstallment}
                        error={
                          formik?.touched?.noOfInstallment && formik?.errors?.noOfInstallment
                            ? formik?.errors?.noOfInstallment
                            : false
                        }
                        onBlur={formik?.handleBlur}
                      />
                    </InputFieldContainerInstallmentWeb>
                  </InputWrapperFOLIO>
                </StyledCol>
                <StyledCol xs={6} md={4} disable={formik?.values?.sipOrLumpsumOption !== constants.SIP}></StyledCol>
                </>
              )}

              {isMobile ? (
                <StyledColAmountMobile xs={12} md={2}>
                  {formik?.values?.sipOrLumpsumOption === constants.SIP ? (
                    <InputWrapperMobileSIP reduceWidth={true}>
                      <InputFieldLabelMobile>{constants.INVESTMENT_AMOUNT}</InputFieldLabelMobile>
                      <InputFieldContainerMobile>
                        <Input
                          name="amount"
                          maxLength="12"
                          className="inputField-v2"
                          inputStylingProps={inputStylingProps}
                          onBlur={formik?.handleBlur}
                          innerRef={investmentAmountRef}
                          onChange={(e) => {
                            onChange('amount', onAmountChange(e.target.value));
                          }}
                          value={formik?.values?.amount !== '' ? formatMoneyWithoutRupeeSymbol(formik?.values?.amount, 0) : ''}
                          error={formik?.touched?.amount && formik?.errors?.amount ? formik?.errors?.amount : ''}
                          inputMode="numeric"
                        />
                      </InputFieldContainerMobile>
                      <InputFieldLabelMobile>{`${constants.MINIMUM} ${formik?.values?.sipOrLumpsumOption === constants.SIP
                            ? formatMoney(getMinimumSipAmount(formik?.values?.frequency, sipFrequencies), 0)
                            : formatMoney(minimumAmount, 0)
                            }`}</InputFieldLabelMobile>
                    </InputWrapperMobileSIP>
                  ) : (
                    <InputWrapperMobile reduceWidth={true}>
                      <InputFieldLabelMobile>{constants.INVESTMENT_AMOUNT}</InputFieldLabelMobile>
                      <InputFieldContainerMobile>
                        <Input
                          name="amount"
                          maxLength="12"
                          className="inputField-v2"
                          inputStylingProps={inputStylingProps}
                          onBlur={formik?.handleBlur}
                          innerRef={investmentAmountRef}
                          onChange={(e) => {
                            onChange('amount', onAmountChange(e.target.value));
                          }}
                          value={formik?.values?.amount !== '' ? formatMoneyWithoutRupeeSymbol(formik?.values?.amount, 0) : ''}
                          error={formik?.touched?.amount && formik?.errors?.amount ? formik?.errors?.amount : ''}
                          inputMode="numeric"
                        />
                      </InputFieldContainerMobile>
                      <InputFieldLabelMobile>{`${constants.MINIMUM} ${formik?.values?.sipOrLumpsumOption === constants.SIP
                            ? formatMoney(getMinimumSipAmount(formik?.values?.frequency, sipFrequencies), 0)
                            : formatMoney(minimumAmount, 0)
                            }`}</InputFieldLabelMobile>
                    </InputWrapperMobile>
                  )}
                </StyledColAmountMobile>
              ) : (
                <>
                <StyledColAmount xs={12} md={4}>
                  {formik?.values?.sipOrLumpsumOption === constants.SIP ? (
                    <InputWrapperSIP reduceWidth={true}>
                      <InputFieldLabel>{constants.INVESTMENT_AMOUNT}</InputFieldLabel>
                      <InputFieldContainer>
                        <Input
                          name="amount"
                          maxLength="12"
                          className="inputField-v2"
                          inputStylingProps={inputStylingProps}
                          onBlur={formik?.handleBlur}
                          innerRef={investmentAmountRef}
                          onChange={(e) => {
                            onChange('amount', onAmountChange(e.target.value));
                          }}
                          value={formik?.values?.amount !== '' ? formatMoneyWithoutRupeeSymbol(formik?.values?.amount, 0) : ''}
                          error={formik?.touched?.amount && formik?.errors?.amount ? formik?.errors?.amount : ''}
                          inputMode="numeric"
                        />
                      </InputFieldContainer>
                    </InputWrapperSIP>
                  ) : (
                   <InputWrapperFOLIO reduceWidth={true}>
                      <InputFieldLabel>{constants.INVESTMENT_AMOUNT}</InputFieldLabel>
                      <InputFieldContainer>
                        <Input
                          name="amount"
                          maxLength="12"
                          className="inputField-v2"
                          inputStylingProps={inputStylingProps}
                          onBlur={formik?.handleBlur}
                          innerRef={investmentAmountRef}
                          onChange={(e) => {
                            onChange('amount', onAmountChange(e.target.value));
                          }}
                          value={formik?.values?.amount !== '' ? formatMoneyWithoutRupeeSymbol(formik?.values?.amount, 0) : ''}
                          error={formik?.touched?.amount && formik?.errors?.amount ? formik?.errors?.amount : ''}
                          inputMode="numeric"
                        />
                      </InputFieldContainer>
                    </InputWrapperFOLIO>
                                      )}
                </StyledColAmount>
                <StyledAmountCol isSip={formik?.values?.sipOrLumpsumOption === constants.SIP} xs={6} md={4} >
                <InputFieldLabel>{`${constants.MINIMUM} ${formik?.values?.sipOrLumpsumOption === constants.SIP
                            ? formatMoney(getMinimumSipAmount(formik?.values?.frequency, sipFrequencies), 0)
                            : formatMoney(minimumAmount, 0)
                            }`}</InputFieldLabel>
                </StyledAmountCol>
                </>
              )}
            </StyledRow>
          </Wrapper>
          <StyledRow>
            <StyledCol>
              
              {isMobile ?(
                <>
                  {formik?.values?.sipOrLumpsumOption === constants.SIP ? (
                <ButtonWrapperMobile>
                  {quickSelectAmountSIP?.map((amount, index) => (
                    <StyledButtonWrapper>
                      <StyledButtonMobileView
                        onClick={() => {
                          onChange('amount', onAmountChange(amount));
                          setSelectedAmount(amount);
                        }}
                        style={{
                          backgroundColor: Number(amount) === formik?.values?.amount ? '#97144D' : '',
                          color: Number(amount) === formik?.values?.amount ? '#fff' : '',
                        }}
                      >
                         ₹ {formatMoneyWithoutRupeeSymbol(amount, 0)}
                      </StyledButtonMobileView>
                    </StyledButtonWrapper>
                  ))}
                </ButtonWrapperMobile>
                  ):(
                <ButtonWrapperMobile>
                  {quickSelectAmount?.map((amount, index) => (
                    <StyledButtonWrapper>
                      <StyledButtonMobileView
                        onClick={() => {
                          onChange('amount', onAmountChange(amount));
                          setSelectedAmount(amount);
                        }}
                        style={{
                          backgroundColor: Number(amount) === formik?.values?.amount ? '#97144D' : '',
                          color: Number(amount) === formik?.values?.amount ? '#fff' : '',
                        }}
                      >
                         ₹ {formatMoneyWithoutRupeeSymbol(amount, 0)}
                      </StyledButtonMobileView>
                    </StyledButtonWrapper>
                  ))}
                </ButtonWrapperMobile>
                )}
                </>
              ) : (
                <>
                  {formik?.values?.sipOrLumpsumOption === constants.SIP ? (
                    <ButtonWrapperSIP>
                      {quickSelectAmountSIP?.map((amount, index) => (
                        <StyledButtonWrapper>
                          <StyledButton
                            onClick={() => {
                              onChange('amount', onAmountChange(amount));
                              setSelectedAmount(amount);
                            }}
                            style={{
                              backgroundColor: Number(amount) === formik?.values?.amount ? '#97144D' : '',
                              color: Number(amount) === formik?.values?.amount ? '#fff' : '',
                            }}
                          >
                            ₹ {formatMoneyWithoutRupeeSymbol(amount, 0)}
                          </StyledButton>
                        </StyledButtonWrapper>
                      ))}
                    </ButtonWrapperSIP>
                  ) : (
                    <ButtonWrapper>
                      {quickSelectAmount?.map((amount, index) => (
                        <StyledButtonWrapper>
                          <StyledButton
                            onClick={() => {
                              onChange('amount', onAmountChange(amount));
                              setSelectedAmount(amount);
                            }}
                            style={{
                              backgroundColor: Number(amount) === formik?.values?.amount ? '#97144D' : '',
                              color: Number(amount) === formik?.values?.amount ? '#fff' : '',
                            }}
                          >
                            ₹ {formatMoneyWithoutRupeeSymbol(amount, 0)}
                          </StyledButton>
                        </StyledButtonWrapper>
                      ))}
                    </ButtonWrapper>
                  )}
                </>
              )}

              {/* {isMobile ? (
                <StyledWrapperMobile>
                <StyledwrapperButton>
                  MOST POPULAR
                  </StyledwrapperButton>
                  </StyledWrapperMobile>
              ) : (
                <StyledButtonWrapperNew>
                  <StyledButtonNew>{constants.MOST_POPULAR}</StyledButtonNew>
                </StyledButtonWrapperNew>
              )} */}
            </StyledCol>
          </StyledRow>
          {buyDetails?.fundSubCategory === SAVE_TAX_SUB_CAT && (
            <ELSSMessageWrapper>
              <ELSSMessage>ELSS Investments have lock-in period of {LOCK_IN_PERIOD} Years</ELSSMessage>
            </ELSSMessageWrapper>
          )}
          {(formik?.values?.sipOrLumpsumOption === constants.SIP || redirectedFromPlanYourGoalWithSip) &&
            (fundCodeOptionSelected === 'CL346G' || fundCodeOptionSelected === 'CL346D') && (
              <ELSSMessageWrapper>
                <ELSSMessage>
                  Systematic investment allowed for this fund is upto Rs 25,000 per month. Please revise the amount to
                  proceed
                </ELSSMessage>
              </ELSSMessageWrapper>
            )}
          {(formik?.values?.sipOrLumpsumOption === constants.SIP || redirectedFromPlanYourGoalWithSip) &&
            ( fundCodeOptionSelected === 'KMI105') && (
              <ELSSMessageWrapper>
                <ELSSMessage>
                  Systematic investment allowed for this fund is upto Rs 2,500 per month. Please revise the amount to
                  proceed
                </ELSSMessage>
              </ELSSMessageWrapper>
            )}
        </BodyContainer>
         {/* <SIPNoteWrapper
          hasAlreadyInvested={hasAlreadyInvested}
          enable={formik.values.sipOrLumpsumOption === constants.SIP}
        >
          <StyledP2 dangerouslySetInnerHTML={{ __html: constants.SIP_MESSAGE }} />
        </SIPNoteWrapper>  */}
      </TransactionCardWrapper>
    </>
  );
}

const TransactionCardWrapper = styled.div``;

const TransactionCardHeader = styled.div`
background-color:#ECECEC;
position: relative;
border-radius: ${pxToRem(8)} : ${pxToRem(8)} ${pxToRem(8)} 0 0 ;
margin-bottom:  ${pxToRem(16)};
height:${pxToRem(40)};
${up('md')} {
  border-radius: ${pxToRem(8)} ${pxToRem(8)} 0 0 ;
}
`;

const Heading = styled.div`
  position: relative;
  margin-left: 25px;
  padding-top: 11px;
`;

const StyledRow = styled(Row) <{ disable: boolean }>`
  display: ${(props) => (props.disable ? 'none' : '')};
  padding: 0;
  margin-top: -25px;
  margin-left: 4px;
`;

const StyledRowMobile = styled(Row) <{ disable: boolean }>`
  display: ${(props) => (props.disable ? 'none' : '')};
  padding: 0;
  margin-top: 15px;
  margin-left: 4px;
`;

const StyledCol = styled(Col) <{ disable: boolean }>`
  display: ${(props) => (props.disable ? 'none' : '')};
  padding: 0;
  margin: 0;
`;

const StyledAmountCol = styled(Col) <{ isSip: boolean }>`
  margin-top: ${(props) => (props.isSip ? '20px' : '60px')};
  padding: 0;
  margin-left:-130px;
`;

const StyledColHoldings = styled(Col) <{ disable: boolean }>`
  display: ${(props) => (props.disable ? 'none' : '')};
  padding: 0;
  margin-top:25px;
`;


const StyledColFOLIO = styled(Col) <{ disable: boolean }>`
  display: ${(props) => (props.disable ? 'none' : '')};
  padding: 0;
`;
const StyledColFOLIONew = styled(Col) <{ disable: boolean }>`
  display: ${(props) => (props.disable ? 'none' : '')};
  padding: 0;
  margin-top: 5px;
`;

const StyledColSip = styled(Col) <{ disable: boolean }>`
  display: ${(props) => (props.disable ? 'none' : '')};
  padding: 0;
  //margin-right: -13px;
 // min-width: 162px;
`;

const StyledColAmount = styled(Col) <{ disable: boolean }>`
  display: ${(props) => (props.disable ? 'none' : '')};
  padding: 0;
  margin-right: -13px;
  min-width: 162px;
 // outline: 2px solid red;
`;

const StyledColAmountMobile = styled(Col) <{ disable: boolean }>`
  display: ${(props) => (props.disable ? 'none' : '')};
  padding: 0;
 // outline: 2px solid red;
`;

const StyledColLumpsum = styled(Col) <{ disable: boolean }>`
  display: ${(props) => (props.disable ? 'none' : '')};
  padding: 0;
 // max-width: 162px;
 // margin-left: 5px;
`;

const StyledColFolio = styled(Col) <{ disable: boolean }>`
  display: ${(props) => (props.disable ? 'none' : '')};
  padding: 0;
  margin: 0;
  max-width: 90%;
  //margin-left: 5px;

`;

const StyledColSIP = styled(Col) <{ disable: boolean }>`
  display: ${(props) => (props.disable ? 'none' : '')};
  padding: 0;
  margin-top: 12px;
  //margin-left: 5px;
 // outline: 2px solid green;
`;

const StyledColSIPDate = styled(Col) <{ disable: boolean }>`
  display: ${(props) => (props.disable ? 'none' : '')};
  padding: 0;
  margin-top: 11.5px;
  //margin-left: 9px;
 // max-width: 145px;
 // outline: 2px solid blue:
`;


const HeaderContainer = styled.article<{ hasAlreadyInvested?: boolean; nomineeSelected?: boolean }>`
  padding: 0 0};
  padding-top: ${(props) => (props.hasAlreadyInvested ? `${pxToRem(12)}` : '0')};
  ${up('md')} {
    padding: 0 0;
    padding-top: ${(props) => (props.hasAlreadyInvested && props.nomineeSelected ? `${pxToRem(24)}` : '0')};
  }
`;
const Wrapper = styled.article<{ reduceBottomPadding: boolean; removeTopPadding?: boolean }>`
  ${up('md')} {
    padding-top: ${(props) => (props.removeTopPadding ? '0' : pxToRem(32))};
    padding-bottom: ${(props) => (props.reduceBottomPadding ? `0` : `${pxToRem(12)}`)};
  }
`;

const BodyContainer = styled.article`
  padding: ${pxToRem(12)};
  padding-bottom: ${pxToRem(6)};
  //margin-left:3px;
  ${up('md')} {
    padding: 0 ${pxToRem(24)};
    padding-bottom: ${pxToRem(10)};
  }
`;

const TooltipWrapperHoldings = styled.div`
  //position: absolute;
  margin-left: 5rem;
  margin-top: -3.8rem;
  z-index: 4;
  .tooltipStyle {
    box-shadow: 0 ${pxToRem(2)} ${pxToRem(20)} #ed116429;
    border: 0;
    border-radius: ${pxToRem(6)};
    margin-left: -8px;
    ${up('md')} {
      width: ${pxToRem(380)};
    }
  }
  ${up('md')} {
    left: ${pxToRem(160)};
    bottom: ${pxToRem(52)};
  }
`;

const TooltipWrapperFOLIO = styled.div`
  //position: absolute;
  margin-left: ${pxToRem(73)};
  margin-top: -1.2rem;
  z-index: 4;
  .tooltipStyle {
    box-shadow: 0 ${pxToRem(2)} ${pxToRem(20)} #ed116429;
    border: 0;
    border-radius: ${pxToRem(6)};
    margin-left: -8px;
    ${up('md')} {
      width: ${pxToRem(380)};
    }
  }
  ${up('md')} {
    left: ${pxToRem(160)};
    bottom: ${pxToRem(52)};
  }
`;

const TooltipWrapperFOLIODevice = styled.div`
  //position: absolute;
 margin-left: 5.25rem;
  margin-top: -4.80rem;;
  z-index: 4;
  .tooltipStyle {
    box-shadow: 0 ${pxToRem(2)} ${pxToRem(20)} #ed116429;
    border: 0;
    border-radius: ${pxToRem(6)};
    margin-left: -8px;
    ${up('md')} {
      width: ${pxToRem(380)};
    }
  }
  ${up('md')} {
    left: ${pxToRem(160)};
    bottom: ${pxToRem(52)};
  }
`;

const TooltipWrapperHoldingMobile = styled.div`
  //position: absolute;
  margin-left: 4.4375rem;
    margin-top: -1.125rem;
  z-index: 4;
  .tooltipStyle {
    box-shadow: 0 ${pxToRem(2)} ${pxToRem(20)} #ed116429;
    border: 0;
    border-radius: ${pxToRem(6)};
    margin-left: -8px;
    ${up('md')} {
      width: ${pxToRem(380)};
    }
  }
  ${up('md')} {
    left: ${pxToRem(160)};
    bottom: ${pxToRem(52)};
  }
`;

const TooltipWrapper = styled.div`
  //position: absolute;
  margin-left: ${pxToRem(87)};
  margin-top: ${pxToRem(-18)};
  z-index: 4;
  .tooltipStyle {
    box-shadow: 0 ${pxToRem(2)} ${pxToRem(20)} #ed116429;
    border: 0;
    border-radius: ${pxToRem(6)};
    margin-left: -8px;
    ${up('md')} {
      width: ${pxToRem(380)};
    }
  }
  ${up('md')} {
    left: ${pxToRem(160)};
    bottom: ${pxToRem(52)};
  }
`;

const TooltipWrapperHoldingsDevice = styled.div`
  //position: absolute;
  margin-left: 5.1rem;
    margin-top: -4.7rem;
  z-index: 4;
  .tooltipStyle {
    box-shadow: 0 ${pxToRem(2)} ${pxToRem(20)} #ed116429;
    border: 0;
    border-radius: ${pxToRem(6)};
    margin-left: -8px;
    ${up('md')} {
      width: ${pxToRem(380)};
    }
  }
  ${up('md')} {
    left: ${pxToRem(160)};
    bottom: ${pxToRem(52)};
  }
`;

const TooltipHeading = styled(B1)`
  color: #4a4a4a;
  padding-bottom: 16px;
  ${up('md')} {
    padding-bottom: 6px;
  }
`;

const TooltipIcon = styled.div`
  margin-left: 10px;
  margin-top: 1px;
`;

const TooltipIconID = styled.div`
  margin-left: 11px;
  margin-top: 2px;
`;

const TooltipIconMobile = styled.div`
margin-left: -2px;
  margin-top: 1px;
`;

const TooltipIconFolioMobile = styled.div`
margin-left: -2px;
margin-top: -1px;
`;

const TooltipIconFOLIO = styled.div`
margin-left: 7px;
margin-top: 4px;

`;

const TooltipSubHeading = styled(P2)`
  color: ${(props) => props.theme.palette.grey2};
`;

const InputWrapper = styled.article<{ addLeftMargin?: boolean; disable?: boolean; reduceWidth?: boolean }>`
  margin-left: ${(props) => (props.addLeftMargin ? `${pxToRem(16)}` : '0')};
  display: ${(props) => (props.disable ? 'none' : '')};
  max-width: ${(props) => (props.reduceWidth ? `90%` : 'auto')};
  padding-top: ${pxToRem(0)};
  ${up('md')} {
    margin-left: 0;
    max-width: ${pxToRem(307)};
    padding-right: ${pxToRem(32)};
    padding-top: ${pxToRem(0)};
    margin-top: 22px;
  }
`;

const InputWrapperFOLIO = styled.article<{ addLeftMargin?: boolean; disable?: boolean; reduceWidth?: boolean }>`
  margin-left: ${(props) => (props.addLeftMargin ? `${pxToRem(16)}` : '0')};
  display: ${(props) => (props.disable ? 'none' : '')};
  max-width: ${(props) => (props.reduceWidth ? `90%` : 'auto')};
  padding-top: ${pxToRem(0)};
  ${up('md')} {
    margin-left: 0;
    max-width: ${pxToRem(307)};
    padding-right: ${pxToRem(32)};
    padding-top: ${pxToRem(0)};
    margin-top: 25.8px;
  }
  `;

const InputWrapperFOLIODevice = styled.article<{ addLeftMargin?: boolean; disable?: boolean; reduceWidth?: boolean }>`
  margin-left: ${(props) => (props.addLeftMargin ? `${pxToRem(16)}` : '0')};
  display: ${(props) => (props.disable ? 'none' : '')};
  max-width: ${(props) => (props.reduceWidth ? `90%` : 'auto')};
  padding-top: ${pxToRem(0)};
  ${up('md')} {
    margin-left: 0;
    max-width: ${pxToRem(307)};
    padding-right: ${pxToRem(32)};
    padding-top: ${pxToRem(0)};
    margin-top: 16px;
  }
`;

const InputWrapperSIP = styled.article<{ addLeftMargin?: boolean; disable?: boolean; reduceWidth?: boolean }>`
  margin-left: ${(props) => (props.addLeftMargin ? `${pxToRem(16)}` : '0')};
  display: ${(props) => (props.disable ? 'none' : '')};
  max-width: ${(props) => (props.reduceWidth ? `90%` : 'auto')};
  padding-top: ${pxToRem(0)};
  ${up('md')} {
    margin-left: 0;
    max-width: ${pxToRem(307)};
    padding-right: ${pxToRem(32)};
    padding-top: ${pxToRem(0)};
    margin-top: -10px;
  }
`;

const InputWrapperSIPWeb = styled.article<{ addLeftMargin?: boolean; disable?: boolean; reduceWidth?: boolean }>`
  margin-left: ${(props) => (props.addLeftMargin ? `${pxToRem(16)}` : '0')};
  display: ${(props) => (props.disable ? 'none' : '')};
  max-width: ${(props) => (props.reduceWidth ? `98%` : 'auto')};
  padding-top: ${pxToRem(0)};
  ${up('md')} {
    margin-left: 0;
    max-width: ${pxToRem(307)};
    padding-top: ${pxToRem(0)};
    margin-top: -10px;
  }
`;

const InputWrapperMobile = styled.article<{ addLeftMargin?: boolean; disable?: boolean; reduceWidth?: boolean }>`
  margin-left: ${(props) => (props.addLeftMargin ? `${pxToRem(16)}` : '0')};
  display: ${(props) => (props.disable ? 'none' : '')};
  max-width: ${(props) => (props.reduceWidth ? `95%` : 'auto')};
  padding-top: ${pxToRem(0)};
  margin-top: 20px;
  margin-bottom: 20px;
  ${up('md')} {
    margin-left: 0;
    max-width: ${pxToRem(307)};
    padding-right: ${pxToRem(32)};
    padding-top: ${pxToRem(0)}; 
  }
`;

const InputWrapperMobileInstallment = styled.article<{ addLeftMargin?: boolean; disable?: boolean; reduceWidth?: boolean }>`
 // margin-left: ${(props) => (props.addLeftMargin ? `${pxToRem(16)}` : '0')};
  display: ${(props) => (props.disable ? 'none' : '')};
  max-width: ${(props) => (props.reduceWidth ? `90%` : 'auto')};
  padding-top: ${pxToRem(0)};
  margin-top: 13px;
  ${up('md')} {
    margin-left: 0;
    max-width: ${pxToRem(307)};
    padding-right: ${pxToRem(32)};
    padding-top: ${pxToRem(0)}; 
  }
`;

const InputWrapperMobileSIP = styled.article<{ addLeftMargin?: boolean; disable?: boolean; reduceWidth?: boolean }>`
  margin-left: ${(props) => (props.addLeftMargin ? `${pxToRem(16)}` : '0')};
  display: ${(props) => (props.disable ? 'none' : '')};
  max-width: ${(props) => (props.reduceWidth ? `95%` : 'auto')};
  padding-top: ${pxToRem(0)};
  margin-top: -14px;
  margin-bottom: 20px;
  ${up('md')} {
    margin-left: 0;
    max-width: ${pxToRem(307)};
    padding-right: ${pxToRem(32)};
    padding-top: ${pxToRem(0)}; 
  }
`;

const CheckBoxGroupWrapper = styled.article<{ disable: boolean }>`
  display: ${(props) => (props.disable ? 'none' : 'flex')};
  //padding: 5px 5px 0 0;
 margin-left:4px;
  ${up('md')} {
    //width: 30%;
   // min-height: ${pxToRem(72)};
    padding-bottom: 0;
    //padding-top: ${pxToRem(8)};
  }
`;

const StyledCheckBox = styled(CheckBox) <{ enable: boolean }>`
  display: ${(props) => (props.enable ? 'inline-block' : 'none')};
  // margin-right: ${pxToRem(12)};
  min-width: 9rem;
  //padding: 0 0 0 ${pxToRem(4)};
  border-radius: 0;
  border-style: solid;
  border-width: 1px;
  border: none;
  border-bottom: 1px solid #afafaf;
  box-shadow: none;
  margin-top: -10px;
  &.lumpsum-selected {
    border-bottom:3px solid #97144D;
  }
  &.sip-selected {
    border-bottom: 3px solid #97144D; 
}
  ${up('md')} {
    padding: ${pxToRem(8)} ${pxToRem(12)};
    // margin-right: ${pxToRem(6)};
    min-width: ${pxToRem(292)};
  }
  ${down('md')} {
    &.lumpsum-selected {
      margin-right: 10px;
    }
    &.sip-selected {
      margin-left: 10px;
  }
  .checkbox-label {
    white-space: nowrap;
    font-weight:700;
  }
  
  }
`;

const SIPNoteWrapper = styled.article<{ hasAlreadyInvested?: boolean; enable: boolean }>`
  display: ${(props) => (props.enable ? 'inline-block' : 'none')};
  background-color: ${(props) => props.theme.palette.whiteGrey4};
  padding: ${pxToRem(8)} ${pxToRem(12)};
  width: 100%;
  border-radius: ${(props) => (props.hasAlreadyInvested ? `0 0 ${pxToRem(8)} ${pxToRem(8)}` : '0')};
  margin-bottom: 15px;
  ${up('md')} {
    padding: ${pxToRem(16)} ${pxToRem(24)};
  }
`;
const StyledP2 = styled(P2)`
  color: ${(props) => props.theme.palette.grey2};
`;

const ELSSMessageWrapper = styled.div`
  background-color: ${(props) => props.theme.palette.whiteGrey3};
  border-radius: ${pxToRem(4)};
  margin-top: ${pxToRem(8)};
  padding: ${pxToRem(2)} ${pxToRem(8)};
  ${up('md')} {
    width: fit-content;
  }
`;
const ELSSMessage = styled(P3)`
  font-size: ${pxToRem(12)};
`;
const SelectDropDownWrapper = styled.article<{ reduceWidth?: boolean; addLeftMargin?: boolean }>`
  position: relative;
  // margin-left: ${(props) => (props.addLeftMargin ? `${pxToRem(16)}` : '0')};
  max-width: ${(props) => (props.reduceWidth ? `90%` : 'auto')};
  //margin-bottom: ${pxToRem(12)};

  ${up('md')} {
    // margin-left: -22px;
    max-width: ${pxToRem(320)};
    padding-right: ${pxToRem(32)};
    margin-top: 16px;
    }
`;

const SelectDropDownWrapperFOLIO = styled.article<{ reduceWidth?: boolean; addLeftMargin?: boolean }>`
  position: relative;
  // margin-left: ${(props) => (props.addLeftMargin ? `${pxToRem(16)}` : '0')};
  max-width: ${(props) => (props.reduceWidth ? `90%` : 'auto')};
  //margin-bottom: ${pxToRem(12)};

  ${up('md')} {
    // margin-left: -22px;
    max-width: ${pxToRem(320)};
    padding-right: ${pxToRem(32)};
    margin-top: 19px;
  }
`;

const SelectDropDownWrapperSIP = styled.article<{ reduceWidth?: boolean; addLeftMargin?: boolean }>`
  position: relative;
  // margin-left: ${(props) => (props.addLeftMargin ? `${pxToRem(16)}` : '0')};
  max-width: ${(props) => (props.reduceWidth ? `90%` : 'auto')};
  //margin-bottom: ${pxToRem(12)};

  ${up('md')} {
    // margin-left: -22px;
    max-width: ${pxToRem(320)};
    padding-right: ${pxToRem(32)};
    margin-top: 30px;
   // font-weight: 700;
  }
`;


const SelectDropDownWrapperMobile = styled.article<{ reduceWidth?: boolean; addLeftMargin?: boolean }>`
  position: relative;
  // margin-left: ${(props) => (props.addLeftMargin ? `${pxToRem(16)}` : '0')};
  max-width: ${(props) => (props.reduceWidth ? `90%` : 'auto')};
  margin-bottom: ${pxToRem(12)};
  margin-top:13px;
  ${up('md')} {
    // margin-left: -22px;
    max-width: ${pxToRem(320)};
    padding-right: ${pxToRem(32)};    margin-top: 16px;
    font-weight:700;
  }
`;

const InputFieldContainer = styled.div`
  margin-top: ${pxToRem(-18)};
`;

const InputFieldContainerInstallment = styled.div`
  margin-top: ${pxToRem(-15)};
`;


const InputFieldContainerInstallmentWeb = styled.div`
  margin-top: ${pxToRem(-12)};
`;

const InputFieldContainerMobile = styled.div`
  margin-top: ${pxToRem(-18)}; 
  margin-bottom: ${pxToRem(-16)}; 
 //width: 315px;
`;

const InputFieldLabel = styled(P2)`
  margin-top: 6px;
  position: relative;
  top: ${pxToRem(-4)};
  font-weight: 700;
`;

const InputFieldLabelID = styled(P2)`
  margin-top: 6px;
  position: relative;
  //top: ${pxToRem(-4)};
  font-weight: 700;
`;

const InputFieldLabelDeviceSIP = styled(P2)`
  margin-top: 6px;
  position: relative;
  top: -0.5rem;
  font-weight: 700;
`;

const InputFieldLabelSIP = styled(P2)`
  margin-top: 10px;
  position: relative;
  top: ${pxToRem(-4)};
  font-weight: 700;
`;

const InputFieldLabelFOLIO = styled(P2)`
  margin-top: 6px;
  position: relative;
  top: ${pxToRem(-8)};
  font-weight: 700;
`;

const InputFieldLabelMobile = styled(P2)`
  margin-top: 10px;
  position: relative;
  top: ${pxToRem(-4)};
  font-weight:700;
`;

const SelectDropdownContainer = styled.div`

  margin-top: ${pxToRem(-22)};
  ${up('md')}{
    margin-top: ${pxToRem(-26)};

  }}
`;
const SelectDropdownLabel = styled(P2)`
  margin-top: 6px;
  position: relative;
  top: ${pxToRem(-4)};
  font-weight: 700;
`;

const SelectDropdownLabelFolio = styled(P2)`
  margin-top: 6px;
  position: relative;
  top: ${pxToRem(-4)};
  font-weight: 700;
  margin-bottom: 2.5px;
`;

const SelectDropdownLabelFOLIO = styled(P2)`
  margin-top: 6px;
  position: relative;
  top: ${pxToRem(-9)};
  font-weight: 700;
`;

const ButtonWrapper = styled.article`
  display: flex;
  // margin-top: ${pxToRem(10)};
  //margin-bottom: ${pxToRem(80)};
  z-index: 0;
  ${up('md')} {
    justify-content: flex-start;
    margin-bottom: ${pxToRem(3)};
    margin-left: -12px;
    margin-top: 8px;
  }
`;

const ButtonWrapperSIP = styled.article`
  display: flex;
  // margin-top: ${pxToRem(10)};
  //margin-bottom: ${pxToRem(80)};
  z-index: 0;
  ${up('md')} {
    justify-content: flex-start;
    margin-bottom: ${pxToRem(3)};
    margin-left: -12px;
    margin-top: -3px;
  }
`;

const ButtonWrapperMobile = styled.article`
  display: flex;
   margin-top: 0.25rem;
  //margin-bottom: ${pxToRem(80)};
  z-index: 0;
  //width: 8.125rem;
  justify-content: space-around;
  ${up('md')} {
    justify-content: flex-start;
    margin-bottom: ${pxToRem(3)};
    //margin-left: -12px;
  }
`;

const StyledButtonWrapper = styled.div`
  display: flex;
  position: relative;
  bottom: 0;
  right: 0;
  left: 0;
  max-width: 100%;
  z-index: 1000;
  background: ${(props) => props.theme.palette.white};
  padding-top: ${pxToRem(12)};
  padding-bottom: ${pxToRem(12)};
  border-top-left-radius: ${pxToRem(12)};
  border-top-right-radius: ${pxToRem(12)};
  ${up('md')} {
    max-width: 100%;
    background: none;
    //position: relative;
    height:55px;
  }
`;

const StyledButton = styled(Button)`
  width: 100%;
  margin: 0 ${pxToRem(12)};
  ${up('md')} {
    margin: 0 0 0 ${pxToRem(12)};
    width: ${pxToRem(130)};
  }
`;

const StyledButtonMobileView = styled(Button)`
 // width: 100%;
 width: 100px;
  margin-right: 5px;
  ${up('md')} {
    //margin: 0 0 0 ${pxToRem(12)};
   // width: ${pxToRem(130)};
  }
`;

const ToolTipIconMobile = styled.div`
  margin-left: -45px;
`;

const ToolTipIconMobileNew = styled.div`
  margin-left: -50px;
  margin-bottom: 4px;
`;

const TooltipSubHeadingNew = styled(P2)`
  color: ${(props) => props.theme.palette.grey2};
`;

const TooltipWrapperNew = styled.div`
  position: absolute;
  left: ${pxToRem(130)};
  bottom: ${pxToRem(42)};
  z-index: 0;
  .tooltipStyle {
    box-shadow: 0 ${pxToRem(2)} ${pxToRem(20)} #ed116429;
    border: 0;
    border-radius: ${pxToRem(6)};
    margin-left: -8px;
    ${up('md')} {
      width: ${pxToRem(380)};
    }
  }
  ${up('md')} {
    left: ${pxToRem(160)};
    bottom: ${pxToRem(52)};
  }
`;
